<script lang="ts">
  import { getContext, onMount } from 'svelte';
  import clsx from 'clsx';
  import { KeyboardArrowDown } from '@athena-lib/Icons';
  import { StackItem } from '@athena-lib/Stack';
  import { HeadingXSmall, Text } from '@athena-lib/Text';
  import { type AccordionContext, type AccordionItemProps, contextKey } from './types';
  let panel: HTMLDivElement = $state(undefined) as unknown as HTMLDivElement;

  const { heading, class: className, children }: AccordionItemProps = $props();
  const context = getContext<AccordionContext>(contextKey);
  const isOpen = $derived(context.isOpen(heading));

  $effect(() => {
    if (isOpen) {
      expandPanel();
    } else {
      collapsePanel();
    }
  });

  let isMounted = $state(false);
  onMount(() => {
    isMounted = true;
  });

  function collapsePanel() {
    const sectionHeight = panel.scrollHeight;

    const panelTransition = panel.style.transition;
    panel.style.transition = '';

    requestAnimationFrame(() => {
      panel.style.height = sectionHeight + 'px';
      panel.style.transition = panelTransition;
      requestAnimationFrame(() => {
        panel.style.height = '0px';
      });
    });
  }

  function expandPanel() {
    const sectionHeight = panel.scrollHeight;
    panel.style.height = sectionHeight + 'px';

    const transitionend = () => {
      panel.removeEventListener('transitionend', transitionend);
      panel.style.height = '';
    };
    panel.addEventListener('transitionend', transitionend);
  }
</script>

<StackItem class={className}>
  <HeadingXSmall>
    <button
      type="button"
      onclick={() => context.toggle(heading)}
      class="flex w-full items-start justify-between text-left"
    >
      <Text class="font-bold">
        {heading}
      </Text>
      <span
        class={clsx(
          isOpen && 'rotate-180',
          'ml-3 mt-[3px] h-5 w-5 shrink-0 transition-transform duration-300',
        )}
      >
        <KeyboardArrowDown />
      </span>
    </button>
  </HeadingXSmall>
  <div
    bind:this={panel}
    class={clsx(
      isOpen ? 'block' : !isMounted && 'hidden',
      'h-auto overflow-hidden transition-all duration-300',
    )}
  >
    <div class="pt-2">
      {@render children()}
    </div>
  </div>
</StackItem>
